export const GET_LIST_CAMDO = "GET_LIST_CAMDO";
export const GET_LIST_CAMDO_SUCCESS = "GET_LIST_CAMDO_SUCCESS";
export const GET_LIST_CAMDO_FAILURE = "GET_LIST_CAMDO_FAILURE";
export const GET_SOTAISANTHANHLY_CAMDO = "GET_SOTAISANTHANHLY_CAMDO";
export const GET_SOTAISANTHANHLY_CAMDO_SUCCESS =
  "GET_SOTAISANTHANHLY_CAMDO_SUCCESS";
export const GET_SOTAISANTHANHLY_CAMDO_FAILURE =
  "GET_SOTAISANTHANHLY_CAMDO_FAILURE";

export const SHOW_FORM_CAM_DO = "SHOW_FORM_CAM_DO";
